export default __webpack_public_path__ + "tmp_src/components/MobileMenu/MobileMenu~aurora.css.liquid";